import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import { NotificationBellPreview, type NotificationLinkProps } from "@ui/react";
import { auth } from "../../lib/firebase";
import { openNotification, toEntry, useNotifications } from "./notifications";

/** Renders the shared link contract as a router `<Link>` — a plain anchor
 *  would throw away the SPA's in-memory state on every click. */
export function RouterLink({ href, ...rest }: NotificationLinkProps) {
  return <Link to={href} {...rest} />;
}

/**
 * The bell: a thin adapter wiring the shared preview to this site's Firestore
 * listener, its own `read` write and its router.
 */
export function NotificationBell() {
  const { items } = useNotifications();
  const { pathname } = useLocation();
  const uid = auth().currentUser?.uid;

  const entries = useMemo(() => items.map(toEntry), [items]);

  return (
    <NotificationBellPreview
      entries={entries}
      href="/notifications"
      current={pathname === "/notifications"}
      onOpen={(entry) => openNotification(uid, entry)}
      renderLink={RouterLink}
    />
  );
}
